import React from 'react';
import './Menu-Categories.scss';

const MenuCategories = () => {
    return (
        <div>

        </div>
    );
};

export default MenuCategories;